import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/en-ca";
import "dayjs/locale/es";
import "dayjs/locale/es-mx";
import "dayjs/locale/fr";
import "dayjs/locale/fr-ca";
import "dayjs/locale/it";
import "dayjs/locale/pl";
import "dayjs/locale/pt-br";
import "dayjs/locale/hu";
import "dayjs/locale/de-ch";
import "dayjs/locale/fr-ch";
import "dayjs/locale/it-ch";

import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";

dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(isBetween);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
